export const borderWidth = {
  None: "0px",
  Hairline: "0.063rem",
  Thin: "0.125rem",
  Thick: "0.25rem",
  Heavy: "0.5rem",
} as const;
